var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51px",
    height: "31px",
    viewBox: "0 0 51 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Send text") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.0572429,14.1706016 C26.6974403,19.7575562 21.9027978,24.4695266 15.9060876,25.131018 C12.937716,25.4613435 10.0411233,24.8477619 7.53159088,23.3650798 C7.38349031,23.2776654 7.21358352,23.2331177 7.04276813,23.2331177 C6.93464563,23.2331177 6.82561454,23.2516092 6.72203499,23.2877517 C5.34460882,23.7685307 3.99898339,24.0366574 2.93229584,24.1862705 C3.92447881,22.5783505 3.97717717,20.5266345 2.98317702,18.6968165 C1.86288251,16.6350143 1.43220969,14.3168526 1.73567957,11.9936477 C2.45346761,6.49410749 7.51069325,2.0721174 13.4983176,1.70817105 C17.1590366,1.47870835 20.7379823,2.72268199 23.3274708,5.10220184 C25.9151421,7.48256222 27.2743965,10.7874976 27.0572429,14.1706016 M24.4840846,3.91012871 C21.5616622,1.19093061 17.5101221,-0.228768182 13.3921632,0.030123013 C6.63002247,0.447038703 0.918912616,5.502982 0.107527529,11.7920207 C-0.234438973,14.4439743 0.252930609,17.0934063 1.51847593,19.4520059 C2.41064051,21.1154659 2.13240005,23.013441 0.824669879,24.1750891 C0.67836925,24.3062158 0.523093121,24.428937 0.359739044,24.5449337 C0.0500843374,24.7617971 -0.076470195,25.1400472 0.0464941379,25.482994 C0.168560921,25.8259408 0.511424973,26.0579342 0.897371419,26.0579342 L0.898268969,26.0579342 C1.02213085,26.0579342 3.85390071,26.0428042 7.03032971,25.0038772 C9.2706142,26.2554648 11.7649053,26.8993306 14.3471563,26.8993306 C14.9269735,26.8993306 15.5130736,26.8665489 16.1000712,26.8009855 C22.8747777,26.0444853 28.2896961,20.6582036 28.6953886,14.2708198 C28.9413173,10.4059441 27.406507,6.62932681 24.4840846,3.91012871",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-22.6%",
    y: "-20.4%",
    width: "145.3%",
    height: "148.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.4 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.53960782,2.0031794 C1.53960782,1.58573363 1.85222772,1.31490751 2.40157135,1.31490751 C3.02590762,1.31490751 3.6854814,1.55491548 4.18061349,2.07602229 L4.90524111,0.971238498 C4.29987888,0.334330175 3.49303042,0 2.52083675,0 C1.08152028,0 0.201486235,0.9600319 0.201486235,2.11804703 C0.201486235,4.73572156 3.72162243,3.89055729 3.72162243,5.10086988 C3.72162243,5.50804295 3.38280028,5.87319127 2.65817266,5.87319127 C1.81518316,5.87319127 1.14567061,5.43520006 0.714688842,4.92343208 L-4.05052286e-15,6.08144721 C0.577352933,6.73796708 1.42034243,7.18716489 2.60396111,7.18716489 C4.24476381,7.18716489 5.05161228,6.22713299 5.05161228,4.95518411 C5.05161228,2.35805501 1.53960782,3.09862436 1.53960782,2.0031794",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-128.7%",
    y: "-76.5%",
    width: "357.3%",
    height: "280.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.4 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "9.29173129 4.47566464 7.76658418 0.0718716489 5.89354766 0.0718716489 5.89354766 7.11529324 7.22944295 7.11529324 7.22944295 2.03646629 9.00043191 7.11529324 9.58303068 7.11529324 11.3530919 2.03646629 11.3530919 7.11529324 12.699192 7.11529324 12.699192 0.0718716489 10.8168784 0.0718716489"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-95.5%",
    y: "-78.1%",
    width: "291.0%",
    height: "284.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.4 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.2210577,2.0031794 C15.2210577,1.58573363 15.5336776,1.31490751 16.0830213,1.31490751 C16.7073575,1.31490751 17.3669313,1.55491548 17.8620634,2.07602229 L18.586691,0.971238498 C17.9813288,0.334330175 17.1744803,0 16.2022867,0 C14.7629702,0 13.8829362,0.9600319 13.8829362,2.11804703 C13.8829362,4.73572156 17.4030723,3.89055729 17.4030723,5.10086988 C17.4030723,5.50804295 17.0642502,5.87319127 16.3396226,5.87319127 C15.4966331,5.87319127 14.8271205,5.43520006 14.3961388,4.92343208 L13.6814499,6.08144721 C14.2588029,6.73796708 15.1017923,7.18716489 16.285411,7.18716489 C17.9262137,7.18716489 18.7330622,6.22713299 18.7330622,4.95518411 C18.7330622,2.35805501 15.2210577,3.09862436 15.2210577,2.0031794",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-128.7%",
    y: "-76.5%",
    width: "357.3%",
    height: "280.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.4 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Send-text",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SMS-icon",
    transform: "translate(11.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-5"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(4.973332, 10.189140)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-51"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-52"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-6)",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-53"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-8)",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-7"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendText);
export default __webpack_public_path__ + "static/media/Send_text.fe4cee232935620c961be21a45a185af.svg";
export { ForwardRef as ReactComponent };